<script>
  export default {
    name: 'PDPPriceGroupBlock',
    props: {
      currentPriceNumber: {
        type: String,
        required: true
      },
      comparePriceNumber: {
        type: String,
        required: true
      },
      showPercentage: {
        type: Boolean,
        required: true
      },
      showOriginalOnSalePrice: {
        type: Boolean,
        required: true
      }
    },
    data() {
      return {
        currentPrice: '',
        comparePrice: '',
        currencyCode: ''
      };
    },
    computed: {
      percentage: function () {
        return this.handlePercentage();
      }
    },
    mounted() {
      this.currencyCode = window.Shopify.currency.active;
      this.currentPrice = this.convertToCurrency(this.currentPriceNumber);
      this.comparePrice = this.convertToCurrency(this.comparePriceNumber);
      // console.log(this.currentPrice, this.comparePrice);
    },
    methods: {
      handlePercentage() {
        if (this.currentPriceNumber && this.showPercentage == 'true' && this.comparePriceNumber != '') {
          if (isFinite(Math.round(((this.comparePriceNumber - this.currentPriceNumber) / this.comparePriceNumber) * 100))) {
            return Math.round(((this.comparePriceNumber - this.currentPriceNumber) / this.comparePriceNumber) * 100);
          }
          return '';
        } else {
          return '';
        }
      },
      checkClass() {
        const compare = parseFloat(this.comparePriceNumber) || 0;
        const current = parseFloat(this.currentPriceNumber) || 0;
        if (compare > 0 && compare > current) {
          return 'product__price--sale';
        } else {
          return '';
        }
      },
      convertToCurrency(str) {
        let dollarUS = Intl.NumberFormat('en-US', {
          style: 'currency',
          currency: this.currencyCode
        });

        let price = dollarUS.format(str).replace('.00', '');

        if (price.includes('CA')) {
          price = price.replace('CA', '');
          price = price + ' CAD';
        }
        if (!isNaN(str)) {
          return price;
        } else {
          return '';
        }
      }
    }
  };
</script>

<template>
  <div class="PDPPriceGroupBlock">
    <div>
      <span data-product-price :class="checkClass() + ' gt-p__small'" v-html="currentPrice"></span>
      <span class="pdp-sale markdown gt-p__small" data-price-sale-amount v-html="comparePrice" v-if="parseFloat(comparePriceNumber) > 0 && parseFloat(comparePriceNumber) > parseFloat(currentPriceNumber) && showOriginalOnSalePrice === true"></span>
      <span class="gt-p__small on-sale percentage" v-html="'(' + percentage + '% off)'" v-if="percentage != '' && percentage > 0"></span>
    </div>
  </div>
</template>

<style lang="scss">
  .PDPPriceGroupBlock {
    .product__price--sale {
      margin-right: 3px;
    }
    .percentage.on-sale {
      font-size: 11px;
      margin-left: 3px;
    }
    .pdp-price-block {
      display: flex;
      flex-direction: column;
    }
  }
</style>
